module.exports = __webpack_public_path__ + "img/UG.7c3d4ca5.svg";